module.exports = "<div translate-namespace=.tunnel> <div class=row> <div ng-repeat=\"config in $ctrl.tunnelConf\"> <div class=col-md-6> <load-file-form details=config id-prefix=tunnel on-update=\"$ctrl.files[config.property] = fileContent\" file-content=$ctrl.files[config.property]></load-file-form> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/wizard-tunnel/wizard-tunnel.html
// module id = 64
// module chunks = 0